import React, { useEffect, useRef } from "react";
import { api } from "@/lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const done = useRef(false);
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(window.location.hash.replace("#", "")).get("session_id");
    const role = localStorage.getItem("pending_role") || null;
    (async () => {
      try {
        const res = await api.post("/auth/session", { role }, { headers: { "X-Session-ID": sid } });
        localStorage.removeItem("pending_role");
        const u = res.data;
        let dest = "/talent";
        if (u.role === "owner" || u.role === "admin") dest = "/admin";
        else if (u.role === "salesman") dest = "/create-profile";
        else if (u.role === "business" && (!u.address || !u.phone)) dest = "/create-profile";
        window.location.href = dest;
      } catch (e) {
        window.location.href = "/login";
      }
    })();
  }, []);

  return (
    <div className="mesh-bg min-h-screen flex items-center justify-center">
      <div className="glass rounded-2xl px-10 py-8 text-center">
        <div className="w-10 h-10 border-2 border-violet-500 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-slate-300">Signing you in…</p>
      </div>
    </div>
  );
}
